import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment';
import { Server } from '../../../../shared/models/server.models';
import { WebsiteData } from '../../../../shared/models/website-overview.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-group-information',
  imports: [
    MatCardModule,
    FontAwesomeModule,
    MatButtonModule,
    MatTooltipModule,
    ClipboardModule,
    NgClass,
    RouterLink,
  ],
  templateUrl: './group-information.component.html',
  styleUrl: './group-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupInformationComponent {
  private snackbar = inject(MatSnackBar);

  websiteData = input.required<WebsiteData>();

  server = input<Server | null>();

  // sshLogin = computed(() => `sshpass -p '${password}' ssh ${username}@${server}`)

  groupInfo = [
    {
      label: 'ID',
      text: (value: WebsiteData) => value.websiteGroup?.id,
    },
    {
      label: 'Plan',
      text: (value: WebsiteData) => value.hostingPlan?.name,
    },
    {
      label: 'Main domain',
      text: (value: WebsiteData) => value.websiteGroup?.mainWebsite?.domain,
      class: (value: WebsiteData) => (value.website.type === 'MAIN' ? '' : 'link'),
      tooltip: (value: WebsiteData) =>
        value.website.type === 'MAIN' ? '' : 'Go to main site settings',
      routerLink: (value: WebsiteData) => `/overview/${value.websiteGroup?.mainWebsite?.id}`,
    },
    {
      label: 'Used site slots',
      text: (value: WebsiteData) =>
        `${value.websiteGroup?.websitesCount} / ${value.hostingPlan?.websitesCountLimit}`,
    },
    {
      label: 'SSH user',
      text: (value: WebsiteData) => value.systemUser?.name,
    },
    {
      label: 'Created At',
      text: (value: WebsiteData) =>
        moment(value.websiteGroup?.mainWebsite?.createdAt).format('DD.MM.YYYY, hh:mm:ss'),
    },
  ];

  onCopied(success: boolean) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: 'SSH Login copied!',
        },
      });
    }
  }
}
